export default async function ({ method = 'GET', path = '/', body = {}, initData = '' }): Promise<any> {
    const base = `https://v2-ru.sanctions.gg`

    const postParams =
        method !== 'GET'
            ? {
                  body: JSON.stringify(body)
              }
            : {}

    const res = await fetch(base + path, {
        method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: initData
        },
        ...postParams
    })

    const json = await res.json()

    if (res.status > 400) {
        throw new Error(json.message)
    }

    return json
}
